import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import { PACOCA_URL } from "../../global-components/src/utils/vars";
import { EMAIL_PACOCA, LINK_DISCORD, LINK_WHATSAPP } from "../../global-components/src/utils/public";

const Suport = () => {
    return (
        <>
            <Screen paddingTopTitle={true} title="Suporte">
                <Helmet>
                        <title>Paçoca - Suporte</title>
                        <meta name="description" content={`Suporte do Paçoca`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, suporte}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Suporte`}/>
                        <meta property="og:description" content={`Suporte do Paçoca`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Suporte`}/>
                        <meta name="twitter:description" content={`Suporte do Paçoca`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <div className="padding-big-screen">
                    <h5>Entre em contato com o suporte:</h5>
                    <br />
                    <p>
                        Mande uma mensagem para o criador: <a href={`${PACOCA_URL}/@joao`}>@joao</a>
                    </p>
                    <p>
                        Faça um post na comunidade de suporte marcando @joao: <a href={`${PACOCA_URL}/comunidades/971`}>{`${PACOCA_URL}/comunidades/971`}</a>
                    </p>
                    <p>
                        Canal public do Discord para suporte, discussões, ideias e novidades: <a target="_BLANK" href={LINK_DISCORD} rel="noopener noreferrer">
                            {LINK_DISCORD}
                        </a>
                    </p>
                    <p>
                        Canal WhatsApp: <a target="_BLANK" href={LINK_WHATSAPP} rel="noopener noreferrer">
                            {LINK_WHATSAPP}
                        </a>
                    </p>
                    <p>
                        Email: <a href={`mailto:${EMAIL_PACOCA}`}>{EMAIL_PACOCA}</a>
                    </p>
                </div>
            </Screen>
        </>
    );
};

export default Suport;